import { getEnv } from "./env";

const CARTO_VOYAGER_RASTER_TILE_SUBDOMAINS = ["a", "b", "c", "d"];

export const getCartoVoyagerRasterTileUrls = () => {
  const apiKey = getEnv().NEXT_PUBLIC_CARTO_BASEMAPS_KEY;
  const keyQueryParam = apiKey ? `?key=${encodeURIComponent(apiKey)}` : "";

  return CARTO_VOYAGER_RASTER_TILE_SUBDOMAINS.map(
    (subdomain) =>
      `https://${subdomain}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png${keyQueryParam}`
  );
};
